/**
 * noticed. Shopify Theme - JavaScript
 * Handles interactive features, product selection, and Xendit integration
 */

document.addEventListener('DOMContentLoaded', function() {
  initColorSwatches();
  initSizeButtons();
  initCartFunctionality();
  initLanguageToggle();
  initProductVariants();
  initMobileMenu();
});

/**
 * Color Swatch Selection
 */
function initColorSwatches() {
  const swatches = document.querySelectorAll('.color-btn');
  
  swatches.forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      swatches.forEach(s => s.classList.remove('active'));
      this.classList.add('active');
      updateProductVariant();
    });
  });
}

/**
 * Size Button Selection
 */
function initSizeButtons() {
  const buttons = document.querySelectorAll('.size-btn');
  
  buttons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      buttons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      updateProductVariant();
    });
  });
}

/**
 * Update Product Variant
 */
function updateProductVariant() {
  const selectedColor = document.querySelector('.color-btn.active');
  const selectedSize = document.querySelector('.size-btn.active');
  
  if (selectedColor && selectedSize) {
    const variantId = document.getElementById('variant-id');
    if (variantId) {
      console.log('Selected variant:', {
        color: selectedColor.textContent,
        size: selectedSize.textContent
      });
    }
  }
}

/**
 * Cart Functionality
 */
function initCartFunctionality() {
  const addToCartBtns = document.querySelectorAll('form button[type="submit"]');
  
  addToCartBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      if (this.textContent.includes('Add to Cart')) {
        handleAddToCart(this);
      }
    });
  });
}

function handleAddToCart(btn) {
  const form = btn.closest('form');
  
  if (form) {
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    
    setTimeout(() => {
      btn.textContent = 'Added!';
      
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    }, 500);
  }
}

/**
 * Language Toggle
 */
function initLanguageToggle() {
  const langBtns = document.querySelectorAll('[data-lang]');
  const currentLang = localStorage.getItem('language') || 'en';
  
  langBtns.forEach(btn => {
    if (btn.dataset.lang === currentLang) {
      btn.classList.add('active');
    }
    
    btn.addEventListener('click', function() {
      const lang = this.dataset.lang;
      localStorage.setItem('language', lang);
      location.reload();
    });
  });
}

/**
 * Product Variants
 */
function initProductVariants() {
  const variantSelects = document.querySelectorAll('select[name^="properties"]');
  
  variantSelects.forEach(select => {
    select.addEventListener('change', updateProductVariant);
  });
}

/**
 * Mobile Menu
 */
function initMobileMenu() {
  const menuBtn = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  
  if (menuBtn && menu) {
    menuBtn.addEventListener('click', function() {
      menu.classList.toggle('active');
      this.classList.toggle('active');
    });
    
    // Close menu when clicking outside
    document.addEventListener('click', function(e) {
      if (!menu.contains(e.target) && !menuBtn.contains(e.target)) {
        menu.classList.remove('active');
        menuBtn.classList.remove('active');
      }
    });
  }
}

/**
 * Xendit Payment Integration
 */
function initXenditPayment() {
  if (!window.Xendit) return;
  
  const xenditPublicKey = document.querySelector('[data-xendit-key]')?.dataset.xenditKey;
  if (!xenditPublicKey) return;
  
  Xendit.setPublishableKey(xenditPublicKey);
  
  const paymentForm = document.querySelector('[data-xendit-form]');
  if (paymentForm) {
    paymentForm.addEventListener('submit', handleXenditPayment);
  }
}

function handleXenditPayment(e) {
  e.preventDefault();
  
  const amount = document.querySelector('[data-amount]')?.dataset.amount;
  if (!amount) return;
  
  const cardData = {
    amount: parseInt(amount),
    currency: 'IDR',
    description: 'noticed. Signature Tee Purchase'
  };
  
  Xendit.createInvoice(cardData, function(error, response) {
    if (error) {
      console.error('Xendit Error:', error);
      alert('Payment failed. Please try again.');
    } else {
      window.location.href = response.invoice_url;
    }
  });
}

/**
 * Utility: Smooth Scroll
 */
function smoothScroll(target) {
  const element = document.querySelector(target);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}

/**
 * Utility: Format Price
 */
function formatPrice(price, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency
  }).format(price);
}

/**
 * Utility: Add to Wishlist
 */
function addToWishlist(productId) {
  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  
  if (!wishlist.includes(productId)) {
    wishlist.push(productId);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    console.log('Added to wishlist:', productId);
  }
}

/**
 * Utility: Remove from Wishlist
 */
function removeFromWishlist(productId) {
  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  wishlist = wishlist.filter(id => id !== productId);
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
  console.log('Removed from wishlist:', productId);
}

/**
 * Export for use in other scripts
 */
window.noticed = {
  smoothScroll,
  formatPrice,
  addToWishlist,
  removeFromWishlist,
  updateProductVariant
};
